export default {
  tiles: [
    {
      title: 'Nerds of Color',
      content:
        'Providing a space to discuss community issues, shared experiences, and strategic goals to further an inclusive culture at NerdWallet.',
      icon: 'https://www.nerdwallet.com/cdn/diversity-inclusion/NoC-logo_color_1c-black-2.png',
      altImage: 'Nerds of Color',
    },
    {
      title: 'NerdOut',
      content:
        'A place for LBGTQIA nerds and allies to support each other and plan fun events together.',
      icon: 'https://www.nerdwallet.com/cdn/diversity-inclusion/NerdOut-Black4c.png',
      altImage: 'NerdOut',
    },
    {
      title: 'NerdWomen',
      content:
        'By offering educational opportunities, connecting over shared experiences, and providing a space for community, we empower women at NerdWallet to achieve professional and personal success.',
      icon: 'https://www.nerdwallet.com/cdn/diversity-inclusion/22Q1_NW_nerdwomen-logo_R1_v1_BK_Color Logo 2.png',
      altImage: 'NerdWomen',
    },
    {
      title: 'NerdParents',
      content:
        'NerdParents We strive to provide a supportive community for parents, soon-to-be parents, and their allies in the WFH and work-from-office world.',
      icon: 'https://www.nerdwallet.com/cdn/diversity-inclusion/Nerd-Parents-Logo_Color.png',
      altImage: 'NerdParents',
    },
    {
      title: 'Women in Data and Engineering ',
      content:
        'We empower, support, mentor and aid in career development for women in data and engineering across all career levels, while collaborating with colleagues to foster inclusion, increase representation and create infrastructures for retention of our diverse talent.',
      icon: 'https://www.nerdwallet.com/cdn/diversity-inclusion/women-in-data-engineering_logos_black-outlines_color-fill-blue.png',
      altImage: 'Women in Data and Engineering ',
    },
  ],
};
